import { Box, Button, List, ListItem, makeStyles, Paper, Typography, useMediaQuery } from "@material-ui/core";
import { useMemo, useState } from "react";
import { DATEPICKER_PREDEFINED, THEME_MODE } from "src/config/constants";
import { toFixed } from "src/services/utils";
import MainDatepicker from "./MainDatepicker";

const useStyle = makeStyles((theme) => ({
  datepicker: {
    padding: "1rem 1rem 0rem 1rem",
    borderRight: `1px solid ${
      theme.palette.type === THEME_MODE.DARK ? "rgba(121, 148, 193, 0.5)" : "rgba(86, 100, 116, 0.2)"
    }`,
  },
  predefinedTitle: {
    color: theme.palette.text.hint,
    fontSize: "12px",
    fontWeight: 400,
    marginBottom: "0.25rem",
  },
  container: {
    padding: "0.5rem 2rem 0.5rem 1rem",
    cursor: "pointer",
    borderRadius: "6px",
    "&:hover": {
      background: theme.palette.type === THEME_MODE.DARK ? "rgba(121, 148, 193, 0.5)" : "rgba(86, 100, 116, 0.2)",
    },
  },
  predefinedItem: {
    fontSize: "13px",
    fontWeight: 400,
    color: theme.palette.text.disabled,
  },
  utilBut: {
    borderTop: `1px solid ${
      theme.palette.type === THEME_MODE.DARK ? "rgba(121, 148, 193, 0.5)" : "rgba(86, 100, 116, 0.2)"
    }`,
    padding: "1rem 0rem 1.5rem 0rem",
    margin: "0rem 1rem 0rem 1rem",
  },
  selectedText: {
    fontSize: "12px",
    fontWeight: 400,
    color: theme.palette.text.hint,
    marginRight: "0.5rem",
  },
  selectedValue: {
    color: theme.palette.text.disabled,
  },
}));

export default function DatepickerPaper({ startDate, endDate, event, ...props }) {
  const cls = useStyle();
  const match = useMediaQuery((theme) => theme.breakpoints.only("xs"));
  const [start, setStart] = useState(startDate);
  const [end, setEnd] = useState(endDate);

  const value = useMemo(() => {
    if (end) {
      const _temp = (end.getTime() - start.getTime()) / (1000 * 3600 * 24);
      return toFixed(_temp + 1);
    }
    return 1;
  }, [start, end]);

  const onPredefinedClick = (value) => {
    const currentDate = new Date();
    let _startDate = new Date();
    _startDate.setDate(_startDate.getDate() - value + 1);
    setStart(_startDate);
    setEnd(currentDate);
    if (event?.onPredefinedClick) event.onPredefinedClick();
  };

  const onCancelClick = () => {
    setStart(startDate);
    setEnd(endDate);
    if (event?.onCancelClick) event.onCancelClick();
  };

  const onContinueClick = () => {
    if (event?.onContinueClick) event.onContinueClick(start, end);
  };

  return (
    <Paper style={{ boxShadow: "0px 3px 12px #0000001F", overflowX: "scroll" }} {...props}>
      <Box display="flex" mb={2}>
        <MainDatepicker
          startDate={start}
          setStart={setStart}
          endDate={end}
          setEnd={setEnd}
          classes={{ root: cls.datepicker }}
        />
        <Box pt={1} pr={1} pl={1}>
          <Typography className={cls.predefinedTitle}>Predefined dates</Typography>
          <List>
            {DATEPICKER_PREDEFINED.map((element, index) => {
              return (
                <ListItem key={index} style={{ minWidth: "115px" }} onClick={() => onPredefinedClick(element["value"])}>
                  <Typography className={cls.predefinedItem}>{element["text"]}</Typography>
                </ListItem>
              );
            })}
          </List>
        </Box>
      </Box>
      <Box display="flex" justifyContent="space-between" alignItems="center" className={cls.utilBut}>
        <Button variant="outlined" color="primary" onClick={() => onCancelClick()}>
          Cancel
        </Button>
        <Box display="flex" justifyContent="flex-end" alignItems="center">
          {!match && (
            <Typography className={cls.selectedText}>
              Selected: <span className={cls.selectedValue}>{value <= 1 ? `${value} day` : `${value} days`}</span>
            </Typography>
          )}
          <Button variant="contained" color="primary" onClick={() => onContinueClick()}>
            Continue
          </Button>
        </Box>
      </Box>
    </Paper>
  );
}
